import { Button } from "src/components/button/Button"
import RadioInput from "src/components/radio-input/RadioInput"
import { Heading } from "src/utils"
import { RadioLabel } from "../../../modules/investment-module/InvestmentModule"
import s from "./ThirdMiddleStep.module.scss"
import cn from "classnames"

interface ThirdMiddleStepProps {
    onPreviousStep: () => void
    onNextStep: () => void
    radioLabels: RadioLabel[]
    radioCheckedValue: string
    setRadioCheckedValue: (value: string) => void
    thirdMiddleStepNumber: string
    thirdMiddleStepHeading: string
    thirdMiddleStepDescription: string
    middleStepPreviousButtonLabel: string
    thirdMiddleStepSeeResultButtonLabel: string
    sharedClasses: {stepContainer: string, buttonContainer: string, textContainer: string, description: string}
}
export default function ThirdMiddleStep({ onPreviousStep, onNextStep, radioLabels, radioCheckedValue, setRadioCheckedValue, thirdMiddleStepNumber,
    thirdMiddleStepHeading,
    thirdMiddleStepDescription, middleStepPreviousButtonLabel, thirdMiddleStepSeeResultButtonLabel, sharedClasses } : ThirdMiddleStepProps) {
    return (
        <div className={sharedClasses.stepContainer}>
            <div className={sharedClasses.textContainer}>
                <p className="label-200">{thirdMiddleStepNumber}</p>
                <Heading className="heading-300">
                    {thirdMiddleStepHeading}
                </Heading>
                <p className={cn(sharedClasses.description, "paragraph-100")}>{thirdMiddleStepDescription}</p>
            </div>
            <ul className={s["investment-step__radio-list"]}>
                {radioLabels.map((radioLabel) => {
                    return (
                        <RadioInput
                            radioLabel={radioLabel.radioLabel}
                            key={radioLabel.id}
                            radioCheckedValue={radioCheckedValue}
                            setRadioCheckedValue={setRadioCheckedValue}
                        />
                    )
                })}
            </ul>
            <div className={cn(s["button-container"], sharedClasses.buttonContainer)}>
                <Button arrowLeft onClick={onPreviousStep}>{middleStepPreviousButtonLabel}</Button>
                <Button pill onClick={onNextStep}>{thirdMiddleStepSeeResultButtonLabel}</Button>
            </div>
        </div>
    )
}
